import React from 'react';
import AppConfig from 'Config/AppConfig';
import AuthFooter from '../../../Components/AuthFooter/AuthFooter';
import styles from './Auth2Error.module.less';
import PiplLogo from '../../../../../static/img/pipl_logo.svg';

export const Auth2ErrorNoAccess = () => {
  const sefUrl = window.__INITIAL_STATE?.sef_url || '/';

  return (
    <>
      <div className={styles.centerForm}>
        <a href={sefUrl}>
          <img className={styles.logo} src={PiplLogo} alt="Pipl" width="120" height="75" />
        </a>

        <div className={styles.wrapper}>
          <div className={`${styles.textBlock} ${styles.text} ${styles.boldText}`}>
            Seems like you have no permission for this login
          </div>
          <div className={styles.textBlock}>
            <span className={styles.text}>
              It looks like your account doesn&#39;t have access to log in via Single Sign-On (SSO).
            </span>
          </div>
          <div className={styles.textBlock}>
            <span className={`${styles.text} ${styles.boldText}`}>
              Please contact your administrator or the support team to request access.
            </span>
          </div>
        </div>

        <a className={styles.btn} href={`/${AppConfig.ACCOUNTS_PREFIX}login/`} id="submit-id-login">
          Try a different account
        </a>
      </div>
      <AuthFooter />
    </>
  );
};

export default Auth2ErrorNoAccess;
